// extracted by mini-css-extract-plugin
export var collapsible = "Collapsible_collapsible__28yfI";
export var content = "Collapsible_content__2rHz4";
export var contentOpen = "Collapsible_contentOpen__y4-54";
export var iconClosed = "Collapsible_iconClosed__bFnIo";
export var iconOpen = "Collapsible_iconOpen__7juyE";
export var title = "Collapsible_title__lL3j9";